import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import * as React from "react";
import translate from "../../../i18n/translate";
import SAA_JSON from "./FeatureCourse/stressAndIntonationList.json";
import "./stressAndIntonation.scss";
import { CircularProgress, Dialog, DialogContent } from "@material-ui/core";
import { getIcons } from "./GetIcons";
import { useSelector } from "react-redux";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";

const StressAndAnnotation = () => {
  const [isAccessible, setIsAccessible] = React.useState<boolean | null>(null);
  const [showLoader, setShowLoader] = React.useState<boolean>(true);
  const [course, setCourse] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState<any>(false);
  const [showCourse, setShowCourse] = React.useState<string>("");
  const [showCategory, setShowCategory] = React.useState<string>("");
  const [showItems, setShowItems] = React.useState<any>([]);
  const { data } = useSelector((state: any) => state.portalLogin);
  const userStateDetails = useSelector((state: any) => state.peopleInformation);

  React.useEffect(() => {
    if (userStateDetails && userStateDetails.data && userStateDetails.data.getpeopleInformation) {
      const getPeopleInformation = userStateDetails.data.getpeopleInformation;
      if (getPeopleInformation.serviceConfiguration.features.substring(53, 54) !== "1") {
        setIsAccessible(false);
      } else if (getPeopleInformation.serviceConfiguration.features.substring(53, 54) === "1") {
        setIsAccessible(true);
      }

      if (SAA_JSON && Object.keys(SAA_JSON).length > 0) {
        const reducedDetails: any = [];
        SAA_JSON.forEach((details: any) => {
          const capitalized = getCapitalized(details.Name);
          details.Description = getTypeDescription(details.Name);
          details.Name = capitalized;
          reducedDetails[capitalized] = details;
        });
        setCourse(reducedDetails);
        setShowLoader(false);
      }
    }
  }, [userStateDetails]);

  const getCapitalized = (title: any) => {
    if (title === undefined || title === "") {
      return "";
    }

    return title.replace(title.at(0), title.at(0).toUpperCase());
  };

  const getTypeDescription = (title: any) => {
    switch (title) {
      case "stress":
        return "Learn which parts of a word to stress in English.";
      case "rhythm":
        return "Find out how to emphasize what's important in your sentences.";
      case "intonation":
        return "Learn how your voice should rise and fall in English.";
      case "linking":
        return "Discover which sounds naturally connect to each other in English.";
      default:
        return "";
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowItems([]);
    setShowCategory("");
    setShowCourse("");
  };

  const toEdgeActivityPlayer = (
    courseType: string,
    categoryName: string,
    activityId: number,
    key: any,
    signature: any
  ) => {
    window.open(
      `${process.env.REACT_APP_PROGRESS_URL}/stressandintonation/${courseType}/${categoryName}/${activityId}?isSimplified=true`,
      "_blank"
    );
  };

  const getPortalLoginDetails = () => {
    if (data && data.getPortalLoginKey && data.getPortalLoginKey.length > 0) {
      const parsedDetails = JSON.parse(data.getPortalLoginKey);
      return {
        key: parsedDetails.key,
        signature: parsedDetails.signature,
      };
    }
    return { key: "", signature: "" };
  };

  const formatCategoryName = (name: string) => {
    return name.toLowerCase().replaceAll(" ", "");
  };

  const formatCategoryFormat = (name: string) => {
    if (name.includes("Reduced Speech")) {
      const spittedText = name.split("Reduced Speech");
      return `Reduced Speech: ${spittedText[1].trim()}`;
    }

    if (name.includes("Consonant")) {
      const spittedText = name.split("Consonant");
      const trimmed2ndWord = spittedText[1].trim();
      const trim2ndWord =
        trimmed2ndWord === "y" ? "/y/" : trimmed2ndWord === "Same" ? "Same Consonant" : trimmed2ndWord;
      return `Consonant + ${trim2ndWord}`;
    }

    if (name === "VowelVowel") {
      return `Vowel + Vowel`;
    }

    return name;
  };

  return isAccessible === null ? (
    <Loader showLoader={showLoader} />
  ) : isAccessible ? (
    <div className="stress-intonation-wrapper">
      <div className="stress-intonation-container">
        <div className="stress-intonation-header-wrapper">
          <h4 className="product-name-title">{translate("stress_intonation_product_headline")}</h4>
          <div className="product-description-container">
            <p className="product-description">{translate("stress_intonation_product_description")}</p>
            {/* <img src={require("./FeatureImage/MicrosoftTeams-image.png")} alt="Stress And Intonation Header Image" /> */}
          </div>
        </div>
        <div className="course-details-list-wrapper">
          {Object.keys(course).length === 0 ? (
            <div className="loader-container">
              <CircularProgress className="stress-and-intonation-loader" />
              <p className="loading-label">Loading</p>
            </div>
          ) : (
            Object.keys(course).map((eachCourse: any) => (
              <div className="each-course-box" key={course[eachCourse].Id}>
                <p className="each-course-title">{course[eachCourse].Name}</p>
                <p className="each-course-description">{course[eachCourse].Description}</p>
                <div className="horizontal-bar"></div>
                <div className="each-course-categories">
                  {course[eachCourse] && course[eachCourse].Categories
                    ? course[eachCourse].Categories.map((eachCategory: any) => (
                        <div
                          className="each-category-box"
                          key={eachCategory.CategoryObjectId}
                          onClick={() => {
                            setShowCourse(course[eachCourse].Name);
                            setShowCategory(eachCategory.CategoryName);
                            setShowItems(eachCategory.Items);
                            setOpen(true);
                          }}
                        >
                          <p className="each-category-title">{formatCategoryFormat(eachCategory.CategoryName)}</p>
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            ))
          )}
        </div>
        {
          <Dialog disableEscapeKeyDown open={open} className={"stress-and-intonation-pop-up"}>
            <DialogContent className="stress-and-intonation-pop-up-contents">
              <div className="close-container">
                <CloseIcon className="close-icon" onClick={handleClose} />
              </div>
              <div className="each-course-items">
                {showItems && showItems.length > 0 && (
                  <>
                    <p className="each-item-showing-category">{formatCategoryFormat(showCategory)}</p>
                    <div className="each-items-list">
                      {showItems.map((eachItem: any) => (
                        <p
                          className="each-item-title"
                          key={eachItem.ActivityId}
                          onClick={() => {
                            const { key, signature } = getPortalLoginDetails();
                            if (key !== "" && signature !== "") {
                              toEdgeActivityPlayer(
                                showCourse.toLowerCase(),
                                formatCategoryName(showCategory),
                                eachItem.ActivityId,
                                key,
                                signature
                              );
                            }
                          }}
                        >
                          <ArrowForwardIcon />
                          {/* TODO: Icons need to be get and added here */}
                          {/* <GeIcon icon={`${eachItem.IconName??""}`} size={20} color="orange" /> */}
                          {/* {getIcons(showCategory === eachItem.ActivityName ? "Presentation" : eachItem.ActivityName)} */}
                          <span className="title-text">{showCategory === eachItem.ActivityName ? "Presentation" : eachItem.ActivityName}</span>
                        </p>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </DialogContent>
          </Dialog>
        }
      </div>
    </div>
  ) : (
    <ErrorPage status={401} />
  );
};

export default StressAndAnnotation;
